import * as React from "react"
import classNames from "classnames"
import { Link } from "react-router-dom"
import { ReactComponent as SliderButton } from "media/svg/SliderButton.svg"
import { Swipeable } from "react-swipeable"
import { Slide } from "types/home"
import "./slideshow.scss"

interface SlideShowProps {
	slides: Slide[]
	buttons?: boolean
	autoplay?: boolean
	dots?: boolean
}

interface SlideShowState {
	currentSlide: number
}

class SlideShow extends React.Component<SlideShowProps, SlideShowState> {
	public static defaultProps = {
		autoplay: false,
		buttons: false,
		dots: false,
	}

	public state: SlideShowState = {
		currentSlide: 0,
	}

	public componentDidMount() {
		const { autoplay } = this.props
		if (autoplay) {
			this.Slideshow = window.setTimeout(this.handleNextSlide, 5000)
		}
	}

	public componentWillUnmount() {
		clearTimeout(this.Slideshow)
	}

	private Slideshow: number | undefined

	private handleNextSlide = () => {
		const { slides } = this.props
		const { currentSlide } = this.state
		const nextSlide =
			currentSlide === slides.length - 1 ? 0 : currentSlide + 1
		this.moveToSlide(nextSlide)()
	}

	private handlePrevSlide = () => {
		const { slides } = this.props
		const { currentSlide } = this.state
		const nextSlide =
			currentSlide === 0 ? slides.length - 1 : currentSlide - 1
		this.moveToSlide(nextSlide)()
	}

	private moveToSlide = (slide: number) => () => {
		const { autoplay } = this.props
		if (autoplay) {
			clearTimeout(this.Slideshow)
			this.Slideshow = window.setTimeout(this.handleNextSlide, 5000)
		}

		this.setState({
			currentSlide: slide,
		})
	}

	public render() {
		const { slides, buttons, dots } = this.props
		const { currentSlide } = this.state
		return slides.length === 0 ? null : (
			<Swipeable
				trackMouse
				className="slideshow__container"
				onSwipedLeft={this.handleNextSlide}
				onSwipedRight={this.handlePrevSlide}
			>
				{slides.map((slide, index) => (
					<Link
						key={`slide-${index}`}
						draggable={false}
						className={classNames(
							"slideshow__slide",
							index !== currentSlide
								? "slideshow__slide__hide"
								: "slideshow__slide__show"
						)}
						to={slide.link}
					>
						<img
							draggable={false}
							src={slide.image_big}
							srcSet={`${slide.image_small} 720w, ${slide.image_big} 1230w`}
							sizes={`(max-width: 425px) 100px, 1230px`}
							alt={slide.title}
							className="slideshow__image"
						/>
					</Link>
				))}
				{buttons && (
					<>
						<button
							draggable={false}
							aria-label={`previous slide`}
							className="slideshow__btn slideshow__btn__prev"
							onKeyUp={this.handlePrevSlide}
							onClick={this.handlePrevSlide}
						>
							<SliderButton className="slideshow__btn__image rotate" />
						</button>
						<button
							draggable={false}
							aria-label={`next slide`}
							className="slideshow__btn slideshow__btn__next"
							onKeyUp={this.handleNextSlide}
							onClick={this.handleNextSlide}
						>
							<SliderButton className="slideshow__btn__image" />
						</button>
					</>
				)}
				{dots && (
					<div className="slideshow__dot__container">
						{slides.map((_slide, index) => (
							<span
								key={`slide-dot-${index}`}
								className={classNames(
									{
										"slideshow__dot--active":
											index === currentSlide,
									},
									"slideshow__dot"
								)}
								role="button"
								tabIndex={0}
								aria-label={`go to slide ${index + 1}`}
								onKeyUp={this.moveToSlide(index)}
								onClick={this.moveToSlide(index)}
							/>
						))}
					</div>
				)}
			</Swipeable>
		)
	}
}

export default SlideShow
